import { useEffect } from "react";
import OurClients from "@/components/OurClients";
import GoogleReviews from "@/components/GoogleReviews";
import Contact from "@/components/Contact";

const OurClientsPage = () => {
  useEffect(() => {
    document.title = "Our Clients - 1000+ Brands Trust BrandBorn | Client Portfolio";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Meet the 1000+ brands that trust BrandBorn for e-commerce onboarding. From fashion to FMCG, our clients sell on Myntra, Nykaa, Ajio, Blinkit, Swiggy Instamart and more. 4.9/5 Google rating.");
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-16" data-testid="our-clients-page">
      <section className="bg-black text-white py-16 px-4">
        <div className="max-w-5xl mx-auto text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-black mb-4">
            Our <span className="text-red-500">Clients</span>
          </h1>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            1000+ brands across Fashion, Beauty, FMCG & more trust BrandBorn to launch and grow on India's top marketplaces.
          </p>
        </div>
      </section>
      <OurClients />
      <GoogleReviews />
      <Contact />
    </div>
  );
};

export default OurClientsPage;
